import SelectCard from "./SelectCard";
import React, { useState } from "react";

const Cards = ({
    page,
    editar = () => { },
    handleArchivar = () => { },
    rowDesarchivar = () => { },
    selects,
    NavigationControl,
    archivo = false,
    notificaciones
}) => {

    const [currentActive, setCurrentActive] = useState({
        id: null
    });

    const selectCheck = (e, index) => {
        let y = document.getElementById(e.target.id);
        let concesionaria = page[index].original;
        if (y.checked) {
            selects(concesionaria, "push");
        } else {
            selects(concesionaria, "pop");
        }
    };

    return (
        <div className="cards__view">
            <div>
                {
                    page.map((item, index) => {
                        return <SelectCard
                            key={index}
                            infoCard={item}
                            editar={editar}
                            handleArchivar={handleArchivar}
                            index={index}
                            selectCheck={selectCheck}
                            archivo={archivo}
                            rowDesarchivar={rowDesarchivar}
                            notificaciones={notificaciones}
                            currentActive={currentActive}
                            setCurrentActive={setCurrentActive}
                        />
                    })
                }
            </div>
            <div className={"cards__navigation"}>
                <NavigationControl />
            </div>
        </div>
    );
}

export default Cards;